import TermsDisclaimer from './TermsDisclaimer';

export default TermsDisclaimer;
